import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { ApplicationExtendedAttributes } from '../ApplicationForm';
import { MDForm } from '../../metadata/MDForm';
import { ProductInfoContext } from '../../data/ApplicationDataSource';
import { DeclaredComponent } from '../../DynamicComponent';
import { ComponentType } from '../../../utils/componentType';
import { errorSink } from '../../ErrorSink';
import { ModelContext } from '../../metadata/ModelSource';
import { Collapse, Icon, Table, Tag, Space } from 'antd';
import InfoTable from '../../layout/InfoTable';
const { Panel } = Collapse;

export function CoveragesForm({ forms, lineCd }) {
  const applicationModel = useContext(ModelContext);
  const { productSetup } = useContext(ProductInfoContext);

  let linePrefix = `lines{lineCd:${lineCd}}.risks[0]`;

  const lineProductSetupContext =
      productSetup.productSubTypes.productSubType[0].productLine[0]
          .productRiskTypes.productRiskType[0];

  if (!lineProductSetupContext) {
    throw 'no product setup found for line ' + lineCd;
  }

  return (
    <MDForm
      prefix={linePrefix}
      productSetupContext={lineProductSetupContext}
      model={applicationModel}
      presentationMetadata={forms}
      extendedAttributes={ApplicationExtendedAttributes}
    >
      <DeclaredComponent declaration={forms} />
    </MDForm>
  );
}

export function getLineProductSetupContext(
  productSetup,
  applicationModel,
  lineCd
) {
  const subTypeProductSetupContext = getSubTypeProductSetupContext(
    productSetup,
    applicationModel
  );
  if (!subTypeProductSetupContext || !subTypeProductSetupContext.productLine) {
    return null;
  }
  return subTypeProductSetupContext.productLine.find(
    (l) => l.lineCd === lineCd
  );
}

export function getSubTypeProductSetupContext(productSetup, applicationModel) {
  if (
    !productSetup.productSubTypes ||
    !productSetup.productSubTypes.productSubType
  ) {
    return null;
  }
  const subTypeCd = applicationModel.getValue('basicPolicy.SubType');
  return subTypeCd
    ? productSetup.productSubTypes.productSubType.find(
        (s) => s.subTypeCd === subTypeCd
      )
    : productSetup.productSubTypes.productSubType[0];
}

CoveragesForm.propTypes = {
  content: ComponentType,
  lineCd: PropTypes.string.isRequired,
};

export function DeductionValueCost({ children, lineCd, content, formTitle }) {
  const applicationModel = useContext(ModelContext);
  const { productSetup } = useContext(ProductInfoContext);
  const [activeKey2, setActiveKey2] = useState('0');

  const lineProductSetupContext = getLineProductSetupContext(
    productSetup,
    applicationModel,
    lineCd
  );

  if (!lineProductSetupContext) {
    throw 'no product setup found for line ' + lineCd;
  }

  return (
    <div>
      <Collapse
        expandIcon={(props) => {
          const { panelKey, isActive } = props;
          return (
            <Icon
              onClick={() => {
                if (activeKey2 === panelKey) {
                  return setActiveKey2('');
                }
                setActiveKey2(panelKey);
              }}
              type={isActive ? 'down' : 'right'}
            />
          );
        }}
        bordered={false}
        activeKey={activeKey2}
        defaultActiveKey={'0'}
        accordion
        style={{ borderBottom: '0px' }}
      >
        <Panel header={formTitle} className='deduction-value-panel'>
            {children}
        </Panel>
      </Collapse>
    </div>
  );
}


export function DwellingBaseCoverages({ children, lineCd, content, formTitle, formText, dwellingCost, dwellingValue }) {
    const applicationModel = useContext(ModelContext);
    const { productSetup } = useContext(ProductInfoContext);
    const [activeKey2, setActiveKey2] = useState('0');
  
    const lineProductSetupContext = getLineProductSetupContext(
      productSetup,
      applicationModel,
      lineCd
    );
  
    if (!lineProductSetupContext) {
      throw 'no product setup found for line ' + 'lineCd';
    }
    const lineProductSetupContextDisplay = lineProductSetupContext.productRiskTypes.productRiskType[0].productCoverages.productCoverage
    return (
      <div>
        <Collapse
          expandIcon={(props) => {
            const { panelKey, isActive } = props;
            return (
              <Icon
                onClick={() => {
                  if (activeKey2 === panelKey) {
                    return setActiveKey2('');
                  }
                  setActiveKey2(panelKey);
                }}
                type={isActive ? 'down' : 'right'}
              />
            );
          }}
          bordered={false}
          activeKey={activeKey2}
          defaultActiveKey={'0'}
          accordion
          style={{ borderBottom: '0px' }}
        >
          <Panel header={formTitle} className='dwelling-coverages'>
            {children}
          </Panel>
        </Collapse>
      </div>
    );
  }
  //<InfoTable content={content} labels={{value: 'Coverage'}, { value: 'Included'}, {value: 'Amount Desired'}, {value: 'Cost'}} prefix={`lines{lineCd:${lineCd}}`} isRisk={false} isHO={true} />

  export function AdditionalCoverages({ children, lineCd, content, formTitle, formText, tableColumnHeaders }) {
    const applicationModel = useContext(ModelContext);
    const { productSetup } = useContext(ProductInfoContext);
    const [activeKey2, setActiveKey2] = useState('0');
  
    const lineProductSetupContext = getLineProductSetupContext(
      productSetup,
      applicationModel,
      lineCd
    );
  
    if (!lineProductSetupContext) {
      throw 'no product setup found for line ' + lineCd;
    }
    const lineProductSetupContextDisplay = lineProductSetupContext.productRiskTypes.productRiskType[0].productCoverages.productCoverage
    return (
      <div>
        <Collapse
          expandIcon={(props) => {
            const { panelKey, isActive } = props;
            return (
              <Icon
                onClick={() => {
                  if (activeKey2 === panelKey) {
                    return setActiveKey2('');
                  }
                  setActiveKey2(panelKey);
                }}
                type={isActive ? 'down' : 'right'}
              />
            );
          }}
          bordered={false}
          activeKey={activeKey2}
          defaultActiveKey={'0'}
          accordion
          style={{ borderBottom: '0px' }}
        >
          <Panel header={formTitle} className='additional-coverage-panel'>
              {children}
          </Panel>
        </Collapse>
      </div>
    );
  }